import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';

import { StatisticOption } from '@mitsubishi/project/data-access';
import { BaseUiModule } from '@mitsubishi/shared/ui';

import { isNil } from '@angular-ru/cdk/utils';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'apm-statistic-data-item',
  templateUrl: './statistic-data-item.component.html',
  styleUrls: ['./statistic-data-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, BaseUiModule, FaIconComponent],
})
export class StatisticDataItemComponent {
  title = input('');
  statisticDataList = input<StatisticOption[]>([]);
  dependsOn = input<string | null>();
  selectedStatisticsCode = model<string | null>();

  onSelectStatistic = output<StatisticOption>();

  statisticDataFiltered = computed(() => {
    if (isNil(this.dependsOn())) {
      return this.statisticDataList();
    }

    return this.statisticDataList().filter(statistic =>
      statistic.dependsOn ? statistic.dependsOn == this.dependsOn() : statistic
    );
  });

  selectStatistic(statistic: StatisticOption) {
    this.selectedStatisticsCode.set(statistic.statisticCode);
    this.onSelectStatistic.emit(statistic);
  }
}
